import { useEffect } from 'react';
import { Text } from '@fluentui/react-components';

export default function SettingsAccount() {
  useEffect(() => {
    window.dispatchEvent(new CustomEvent('setPageContext', {
      detail: { title: 'Account and billing' },
    }));
    return () => {
      window.dispatchEvent(new CustomEvent('setPageContext', { detail: null }));
    };
  }, []);

  return (
    <div style={{ padding: '1rem' }}>
      <Text>Configure account and billing settings here.</Text>
    </div>
  );
}
